import Cookies from 'js-cookie';
import { AuthReducer } from "../../models/store";
import * as actions from '../constants/auth';
import { SignInPayload } from "../../models/auth";

import { REHYDRATE } from "redux-persist";
import { BW, Tower } from "../../api";

const initialState: AuthReducer = {
  isLoading: false,
  isAuthenticated: false,
  token: null,
  userInfo: null,
};

const auth = (state: AuthReducer = initialState, action: { payload?: any, type: string, data?: _.Dictionary<any> }): AuthReducer => {
  const { type, data } = action;
  switch (type) {
    case REHYDRATE: {
      const token = Cookies.get('token');
      if (!token) {
        return {
          ...state,
          isLoading: false,
          token: null,
          userInfo: null,
          isAuthenticated: false,
        }
      }
      BW.setHeaders('Authorization', token);
      Tower.setHeaders('Authorization', token);
      return {
        ...state,
        token,
        isLoading: false,
        userInfo: null,
        isAuthenticated: true,
      }
    }
    case actions.GET_AUTH_TOKEN:
      return {
        ...state,
        isLoading: true,
      };
    case actions.GET_AUTH_TOKEN_FAILED:
      return {
        ...state,
        isLoading: false,
      };
    case actions.GET_AUTH_TOKEN_SUCCESS: {
      const { userInfo, token }: SignInPayload = data.payload;
      Cookies.set('token', token);
      BW.setHeaders('Authorization', token);
      Tower.setHeaders('Authorization', token);
      return {
        ...state,
        token,
        userInfo,
        isLoading: false,
        isAuthenticated: true,
      };
    }
    case actions.REFRESH_TOKEN:
      return {
        ...state,
        isLoading: true,
      };
    case actions.REFRESH_TOKEN_FAILED:
      return {
        ...state,
        isLoading: false,
      };
    case actions.REFRESH_TOKEN_SUCCESS: {
      const { userInfo } = data.payload;
      return {
        ...state,
        userInfo,
        isLoading: false,
        isAuthenticated: true,
      };
    }
    case actions.DESTROY_AUTH_TOKEN:
      BW.setHeaders('Authorization', undefined);
      Tower.setHeaders('Authorization', undefined);  
      Cookies.remove('token');
      return {
        ...state,
        isLoading: false,
        isAuthenticated: false,
        token: null,
        userInfo: null,
      }
    default:
      return state;
  }
}
export default auth;
